import type { TypeSalesRequest } from '@/api/core/type-sales-transition';

// This owner survives route unmounts for the lifetime of this browser page.
interface PendingCommand {
  actorId: string;
  body: TypeSalesRequest;
}
const pending = new Map<string, PendingCommand>();
export const commandScope = (namespace: string, typeId: string) => `${namespace}:${typeId}`;
export const pendingCommand = (scope: string) => pending.get(scope);
export const holdCommand = (scope: string, command: PendingCommand) => {
  if (pending.has(scope)) return false;
  pending.set(scope, command);
  return true;
};
export const settleCommand = (scope: string, command: PendingCommand) => {
  if (pending.get(scope) === command) pending.delete(scope);
};
export const clearPendingCommandsForTest = () => {
  pending.clear();
};
